export default "__VITE_ASSET__D4jyrs3___"